/**
 * DefaultDeliveryCard — configura a ENTREGA PADRÃO (fallback) do bot.
 *
 * É o que "usar entrega padrão" significa para os planos do front. Cada plano
 * pode sobrescrever na tabela; quando fica em "usar padrão", cai aqui.
 *
 * Props:
 * - value: objeto de entrega ({type, url?, message?}) ou null (= Grupo VIP)
 * - onChange: (delivery|null) => void
 */

import { Package, ArrowUpCircle } from 'lucide-react';
import DeliveryTypeField from '../../../components/UI/DeliveryTypeSelect/DeliveryTypeField';
import { DELIVERY_TYPE_META } from '../../../utils/deliveryTypeMeta';
import { applyOnlyUpsellRule } from '../../../utils/gateways';

const DEST_OPTIONS = [
    // Aqui "default" JÁ É o Grupo VIP (não cascateia pra outro nível como nos
    // demais contextos) — por isso usa o ícone de coroa, não o de reset.
    { value: 'default', label: 'Grupo VIP', ...DELIVERY_TYPE_META.vip_group },
    { value: 'message_only', label: 'Mensagem no Bot', ...DELIVERY_TYPE_META.message_only },
    { value: 'external_link', label: 'Link Externo', ...DELIVERY_TYPE_META.external_link },
    { value: 'only_upsell', label: 'Apenas Upsell', ...DELIVERY_TYPE_META.only_upsell },
];

export default function DefaultDeliveryCard({ value, onChange, onlyUpsellBlocked = false }) {
    const type = value?.type || 'default';

    return (
        <div className="panel-card text-white w-full">
            <div className="p-4 md:p-6">
                <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-[rgba(139,92,246,0.1)] border border-[rgba(139,92,246,0.2)] flex items-center justify-center shrink-0">
                        <Package size={18} className="text-[#a78bfa]" />
                    </div>
                    <div>
                        <h3 className="font-semibold text-white text-sm">Entrega Padrão</h3>
                        <p className="text-xs text-white/40">Usada quando o plano está em "usar entrega padrão"</p>
                    </div>
                </div>

                <label className="text-xs text-white/40 mb-1 block">Destino da Entrega</label>
                <DeliveryTypeField
                    value={value}
                    onChange={onChange}
                    options={applyOnlyUpsellRule(DEST_OPTIONS, onlyUpsellBlocked)}
                    showReset
                    resetTitle="Voltar ao padrão (Grupo VIP)"
                    panel
                />

                {type === 'only_upsell' && (
                    <div className="mt-3 p-3 rounded-lg bg-[rgba(139,92,246,0.05)] border border-[rgba(139,92,246,0.2)] flex items-start gap-2">
                        <ArrowUpCircle size={14} className="text-[#a78bfa] mt-0.5 shrink-0" />
                        <p className="text-xs text-white/50">
                            Nenhum entregável é enviado neste momento — o cliente só recebe a oferta de upsell configurada para o bot.
                        </p>
                    </div>
                )}

                <div className="mt-3 p-2 rounded-lg bg-[rgba(139,92,246,0.05)] border border-[rgba(139,92,246,0.2)]">
                    <p className="text-xs text-white/40">
                        <span className="text-[#a78bfa] font-medium">ℹ️ Dica:</span>{' '}
                        Vale para planos em "usar entrega padrão". Cada plano pode ter a sua própria entrega na tabela ao lado.
                    </p>
                </div>
            </div>
        </div>
    );
}
